import { axiosClient } from "./shared/apiConfig";
import { SubscriptionParker } from "./Data/ApiTypes";

export interface GroupParkerFulfillResponse {
    parkers: SubscriptionParker[];
    alreadyFulfilled: boolean;
}

/** Idempotent — creates parkers after Stripe payment succeeds. */
export async function fulfillGroupParkerCheckout(orderId: number): Promise<GroupParkerFulfillResponse> {
    const resp = await axiosClient.post(`/connect/group-parker/checkout/${orderId}/fulfill`);
    const data = resp.data as {
        parkers?: SubscriptionParker[];
        alreadyFulfilled?: boolean;
    };
    return {
        parkers: (data.parkers ?? []) as SubscriptionParker[],
        alreadyFulfilled: data.alreadyFulfilled ?? false,
    };
}
